//
// Action types
//

export const INCREMENT_ERROR_BOUNDARY_KEY = "INCREMENT_ERROR_BOUNDARY_KEY";

//
// Action creators
//

export function incrementErrorBoundaryKey() {
  return {
    type: INCREMENT_ERROR_BOUNDARY_KEY
  };
}

function incrementErrorBoundaryKeyHandler(state) {
  return state + 1;
}

//
// Reducer and handlers
//

export function reduceErrorBoundaryKey(state, action) {
  switch (action && action.type) {
    case INCREMENT_ERROR_BOUNDARY_KEY:
      return incrementErrorBoundaryKeyHandler(state);

    default:
      return state || 0;
  }
}
